import { useIntl } from "react-intl";

import { usePatientName } from "src/features/patient";
import { genericMessages } from "src/messages/generic";
import { useAddress } from "src/modules/ktx/header/hooks/useAddress";
import { useAge } from "src/modules/ktx/header/hooks/useAge";
import { useBloodGroup } from "src/modules/ktx/header/hooks/useBloodGroup";
import { useBmi } from "src/modules/ktx/header/hooks/useBmi";
import { useHeight } from "src/modules/ktx/header/hooks/useHeight";
import { useLongStatus } from "src/modules/ktx/header/hooks/useLongStatus";
import { usePatientEtId } from "src/modules/ktx/header/hooks/usePatientEtId";
import { usePhoneNumber } from "src/modules/ktx/header/hooks/usePhoneNumber";
import { useSocialSecurityNumber } from "src/modules/ktx/header/hooks/useSocialSecurityNumber";
import { useWaitingListTime } from "src/modules/ktx/header/hooks/useWaitingListTime";
import { useWeight } from "src/modules/ktx/header/hooks/useWeight";
import { messages } from "src/modules/ktx/header/messages";

export function useHeaderValues(): { label?: string; value?: string }[] {
	const { formatMessage } = useIntl();
	const name = usePatientName();
	const status = useLongStatus();
	const { value: waitingList, days: isWaitingListDays } =
		useWaitingListTime();
	const { value: patientEtId } = usePatientEtId();
	const ssn = useSocialSecurityNumber();
	const address = useAddress();
	const phoneNumber = usePhoneNumber();
	const { value: bloodGroup } = useBloodGroup();
	const age = useAge();
	const { value: weight } = useWeight();
	const { value: height } = useHeight();
	const { value: bmi } = useBmi();
	return [
		{ label: formatMessage(messages.name), value: name },
		{ label: formatMessage(messages.status), value: status },
		{
			label: formatMessage(messages.waitingList),
			value:
				waitingList === undefined
					? "-"
					: isWaitingListDays
						? formatMessage(genericMessages.days, {
								days: waitingList
							})
						: formatMessage(genericMessages.months, {
								months: waitingList
							})
		},
		{ label: formatMessage(messages.patientEtId), value: patientEtId },
		{ label: formatMessage(messages.ssn), value: ssn },
		{ label: formatMessage(messages.address), value: address },
		{ label: formatMessage(messages.phoneNumber), value: phoneNumber },
		{ label: formatMessage(messages.bloodGroup), value: bloodGroup },
		{ label: formatMessage(messages.age), value: age },
		{ label: formatMessage(messages.weight), value: weight },
		{ label: formatMessage(messages.height), value: height },
		{ label: formatMessage(messages.bmi), value: bmi }
	];
}
